/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_Wave_DescInputs */

const en_mk_loop_wave_desc = /** @type {(inputs: Mk_Loop_Wave_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The server picks ≤4 tasks whose files do not overlap; one leader prompt runs parallel subagents. New projects: the first wave stays sequential.`)
};

const id_mk_loop_wave_desc = /** @type {(inputs: Mk_Loop_Wave_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Server memilih ≤4 task yang file-nya tidak tumpang tindih; satu prompt leader menjalankan subagent paralel. Proyek baru: gelombang pertama tetap sekuensial.`)
};

/**
* | output |
* | --- |
* | "The server picks ≤4 tasks whose files do not overlap; one leader prompt runs parallel subagents. New projects: the first wave stays sequential." |
*
* @param {Mk_Loop_Wave_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_wave_desc = /** @type {((inputs?: Mk_Loop_Wave_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_Wave_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_wave_desc(inputs)
	return en_mk_loop_wave_desc(inputs)
});